import React from 'react'

export default function RailsError({ errors }) {
  return (
    <div className="error">
      <ul>
        {Object.keys(errors).map(error => <li key={error}>{`${error.charAt(0).toUpperCase() + error.slice(1)} ${errors[error]}`}</li>)}
      </ul>
    </div>
  )
}



// WEBPACK FOOTER //
// client/components/util/RailsError.js